export const Months = [
  {label: 'ינואר', value: '01'},
  {label: 'פברואר', value: '02'},
  {label: 'מרץ', value: '03'},
  {label: 'אפריל', value: '04'},
  {label: 'מאי', value: '05'},
  {label: 'יוני', value: '06'},
  {label: 'יולי', value: '07'},
  {label: 'אוגוסט', value: '08'},
  {label: 'ספטמבר', value: '09'},
  {label: 'אוקטובר', value: '10'},
  {label: 'נובמבר', value: '11'},
  {label: 'דצמבר', value: '12'},
];
let currentYear = new Date().getFullYear();
export const Years = [
  {
    label: currentYear - 2,
    value: (currentYear - 2).toString(),
  },
  {
    label: currentYear - 1,
    value: (currentYear - 1).toString(),
  },
  {
    label: currentYear,
    value: currentYear.toString(),
  },
];
